import { nativeBridge } from './nativeBridge';

/**
 * @description 跳转native页面
 */
export function pagetransNative(params) {
  nativeBridge(params);
  return true;
}
